<template>
  <Datatable :total="orderDetails.meta.page.total" :perPage="orderDetails.meta.page.perPage"
    :currentPage="orderDetails.meta.page.currentPage" @pagechanged="onChangePage" :columns="[
      { id: 'order_code', name: 'No Faktur' },
      { id: 'qty', name: 'Jumlah Order' }
    ]">
    <template #tbody="{ classes }">
      <tr v-for="orderDetail in orderDetails.data" :key="orderDetail.id" :class="classes.tr">
        <td :class="classes.td">{{ orderDetail.attributes.order_origin_code }} / {{
          orderDetail.attributes.order_destination_code }}</td>
        <td :class="classes.td">{{ orderDetail.attributes.product_remaining_qty | toCurrency }}</td>
      </tr>
    </template>
  </Datatable>
</template>

<script>
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  props: {
    stockId: String
  },
  data() {
    return {
      orderDetails: {
        data: [],
        meta: {
          page: {}
        }
      }
    }
  },
  methods: {
    async loadOrderDetails(params) {
      const [res, err] = await this.request(`/api/v1/stocks/${this.stockId}/order-details`, {
        params: {
          'filter[has_order_remaining]': true,
          'page[size]': 5,
          ...params
        }
      })

      if (!err) {
        this.orderDetails = res
      }
    },
    onChangePage(page) {
      this.loadOrderDetails({ 'page[number]': page })
    }
  },
  created() {
    this.loadOrderDetails()
  }
}
</script>